module.exports = __webpack_public_path__ + "img/add-posi.c045c77b.png";